import React, { useState, useEffect, Component } from 'react'
import { Button, Checkbox, CheckboxGroup, Col, Panel, Row, SelectPicker, Table } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { budgetFormat } from '../../utils/formatterUtil'
import './styles.less'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { doneLoading, startLoading } from '../../utils/loading'
import { saveManageAccess } from '../../redux/actions/manageAccess'
import notification from '../../utils/notification'
import { SAVE_SUCCESS_MSG } from '../../constants/msgText'

export default function ManageUserGroupsWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isLoading, setIsLoading] = useState(false)

  console.log('schema => ', formSchema)

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await saveManageAccess(request)
      if (response) {
        setFormSchema(response.form)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
      }

    } catch (e) {
      // console.log('error', e)
      if (e?.response?.data) {
        notification.open('error', {
          title: e.response.data.errors?.message,
          duration: 5000,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data => ', data)

    const formData = new FormData()

    let keys = Object.keys(data)?.filter((e) => e)

    console.log('keys', keys)

    keys.forEach((key, index) => {
      let _data = data[key]
      formData.append(`AccessArray[${index}].Role`, key || '')
      //formData.append(`AccessArray[${index}].Name`, _data.name || '')
      formData.append(`AccessArray[${index}].Status`, _data.status || 0)
      formData.append(`AccessArray[${index}].UserRoleMenu`, _data.userRoleMenu || false)
      formData.append(`AccessArray[${index}].ReadEditSubproject`, _data.readEditSubproject || false)
      formData.append(`AccessArray[${index}].ApproveSubproject`, _data.approveSubproject || false)
      formData.append(`AccessArray[${index}].ReadEditProgress`, _data.readEditProgress || false)
      formData.append(`AccessArray[${index}].ReadEditMoneyReport`, _data.readEditMoneyReport || false)
      formData.append(`AccessArray[${index}].ApproveReport`, _data.approveReport || false)
      formData.append(`AccessArray[${index}].CheckReportAndAdvise`, _data.checkReportAndAdvise || false)
      formData.append(`AccessArray[${index}].Seq`, _data.Seq || 0)
    })
     
    handleSave(formData)
  }

  return (
    <>
      <Panel shaded header={formSchema.title} collapsible defaultExpanded>
        <div style={{ overflowX: 'auto' }}>
          <table border={1}>
            <thead>
              <tr>
                {formSchema.headerInput.map((item, index) => {
                  if (item.type == 'display') {
                    return (
                      <th key={index} width={800}>
                        <div style={{ padding: 8, marginTop: 5 }}>{item.label}</div>
                      </th>
                    )
                  }

                  if (item.type == 'select') {
                    return (
                      <th key={index} width={500}>
                        <div style={{ padding: 8, marginTop: 5 }}>{item.label}</div>
                      </th>
                    )
                  }

                  return (
                    <th key={index} width={300}>
                      <div style={{ padding: 8, marginTop: 5 }}>{item.label}</div>
                    </th>
                  )
                })}
              </tr>
            </thead>
            <tbody>
              {formSchema.values.map((item, index) => {
                // console.log('item => ', item)
                return (
                  <tr key={index}>
                    <td>
                      <div style={{ padding: 5, marginTop: 5 }}>{item?.role || ''}</div>
                    </td>
                    <td>
                      <div style={{ padding: 5, marginTop: 5 }}>{item?.name || ''}</div>
                    </td>
                    <td>
                      <div style={{ padding: 5, marginTop: 5 }}>
                        <Controller
                          key={index}
                          name={`${item?.role}.${formSchema.input?.status.name}`}
                          control={control}
                          defaultValue={item.status || 0}
                          render={(props) => {
                            return (
                              <SelectPicker
                                searchable={false}
                                cleanable={false}
                                data={formSchema.input?.status.options}
                                value={props.value}
                                block
                                placeholder="เลือก"
                                onChange={(value) => {
                                  props.onChange(value)
                                }}
                              />
                            )
                          }}
                        />
                      </div>
                    </td>
                    <td>
                      <div
                        style={{
                          padding: 5,
                          marginTop: 5,
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <Controller
                          key={index}
                          // name={`${formSchema.input?.userRoleMenu.name}_${item?.role}${index}`}
                          name={`${item?.role}.${formSchema.input?.userRoleMenu.name}`}
                          control={control}
                          defaultValue={item.userRoleMenu}
                          render={(props) => {
                            return formSchema?.input?.userRoleMenu?.options.map((item, index) => {
                              return (
                                <Checkbox
                                  key={index}
                                  value={item.value}
                                  checked={props.value}
                                  onChange={(e, checked) => {
                                    // console.log('checked => ', checked)
                                    props.onChange(checked)
                                  }}
                                />
                              )
                            })
                          }}
                        />
                      </div>
                    </td>
                    <td>
                      {/* <div style={{ padding: 5, marginTop: 5 }}>
                        {item?.readEditSubproject || ''}
                      </div> */}
                      <div
                        style={{
                          padding: 5,
                          marginTop: 5,
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <Controller
                          key={index}
                          // name={`${formSchema.input?.readEditSubproject.name}_${index}`}
                          name={`${item?.role}.${formSchema.input?.readEditSubproject.name}`}
                          control={control}
                          defaultValue={item.readEditSubproject}
                          render={(props) => {
                            return formSchema?.input?.readEditSubproject?.options.map(
                              (item, index) => {
                                return (
                                  <Checkbox
                                    key={index}
                                    value={item.value}
                                    checked={props.value}
                                    onChange={(e, checked) => {
                                      // console.log('checked => ', checked)
                                      props.onChange(checked)
                                    }}
                                  />
                                )
                              }
                            )
                          }}
                        />
                      </div>
                    </td>
                    <td>
                      {/* <div style={{ padding: 5, marginTop: 5 }}>
                        {item?.approveSubproject || ''}
                      </div> */}
                      <div
                        style={{
                          padding: 5,
                          marginTop: 5,
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <Controller
                          key={index}
                          // name={`${formSchema.input?.approveSubproject.name}_${index}`}
                          name={`${item?.role}.${formSchema.input?.approveSubproject.name}`}
                          control={control}
                          defaultValue={item.approveSubproject}
                          render={(props) => {
                            return formSchema?.input?.approveSubproject?.options.map(
                              (item, index) => {
                                return (
                                  <Checkbox
                                    key={index}
                                    value={item.value}
                                    checked={props.value}
                                    onChange={(e, checked) => {
                                      // console.log('checked => ', checked)
                                      props.onChange(checked)
                                    }}
                                  />
                                )
                              }
                            )
                          }}
                        />
                      </div>
                    </td>
                    <td>
                      {/* <div style={{ padding: 5, marginTop: 5 }}>{item?.readEditProgress || ''}</div> */}
                      <div
                        style={{
                          padding: 5,
                          marginTop: 5,
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <Controller
                          key={index}
                          // name={`${formSchema.input?.readEditProgress.name}_${index}`}
                          name={`${item?.role}.${formSchema.input?.readEditProgress.name}`}
                          control={control}
                          defaultValue={item.readEditProgress}
                          render={(props) => {
                            return formSchema?.input?.readEditProgress?.options.map(
                              (item, index) => {
                                return (
                                  <Checkbox
                                    key={index}
                                    value={item.value}
                                    checked={props.value}
                                    onChange={(e, checked) => {
                                      // console.log('checked => ', checked)
                                      props.onChange(checked)
                                    }}
                                  />
                                )
                              }
                            )
                          }}
                        />
                      </div>
                    </td>
                    <td>
                      {/* <div style={{ padding: 5, marginTop: 5 }}>
                        {item?.readEditMoneyReport || ''}
                      </div> */}
                      <div
                        style={{
                          padding: 5,
                          marginTop: 5,
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <Controller
                          key={index}
                          // name={`${formSchema.input?.readEditMoneyReport.name}_${index}`}
                          name={`${item?.role}.${formSchema.input?.readEditMoneyReport.name}`}
                          control={control}
                          defaultValue={item.readEditMoneyReport}
                          render={(props) => {
                            return formSchema?.input?.readEditMoneyReport?.options.map(
                              (item, index) => {
                                return (
                                  <Checkbox
                                    key={index}
                                    value={item.value}
                                    checked={props.value}
                                    onChange={(e, checked) => {
                                      // console.log('checked => ', checked)
                                      props.onChange(checked)
                                    }}
                                  />
                                )
                              }
                            )
                          }}
                        />
                      </div>
                    </td>
                    <td>
                      {/* <div style={{ padding: 5, marginTop: 5 }}>{item?.approveReport || ''}</div> */}
                      <div
                        style={{
                          padding: 5,
                          marginTop: 5,
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <Controller
                          key={index}
                          // name={`${formSchema.input?.approveReport.name}_${index}`}
                          name={`${item?.role}.${formSchema.input?.approveReport.name}`}
                          control={control}
                          defaultValue={item.approveReport}
                          render={(props) => {
                            return formSchema?.input?.approveReport?.options.map((item, index) => {
                              return (
                                <Checkbox
                                  key={index}
                                  value={item.value}
                                  checked={props.value}
                                  onChange={(e, checked) => {
                                    // console.log('checked => ', checked)
                                    props.onChange(checked)
                                  }}
                                />
                              )
                            })
                          }}
                        />
                      </div>
                    </td>
                    <td>
                      {/* <div style={{ padding: 5, marginTop: 5 }}>
                        {item?.checkReportAndAdvise || ''}
                      </div> */}
                      <div
                        style={{
                          padding: 5,
                          marginTop: 5,
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <Controller
                          key={index}
                          // name={`${formSchema.input?.checkReportAndAdvise.name}_${index}`}
                          name={`${item?.role}.${formSchema.input?.checkReportAndAdvise.name}`}
                          control={control}
                          defaultValue={item.checkReportAndAdvise}
                          render={(props) => {
                            return formSchema?.input?.checkReportAndAdvise?.options.map(
                              (item, index) => {
                                return (
                                  <Checkbox
                                    key={index}
                                    value={item.value}
                                    checked={props.value}
                                    onChange={(e, checked) => {
                                      // console.log('checked => ', checked)
                                      props.onChange(checked)
                                    }}
                                  />
                                )
                              }
                            )
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>

        <Row style={{ marginTop: 20 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {/* <hr /> */}
            <SaveButton onClick={handleSubmit(onSubmit)}>{formSchema.hedaer}</SaveButton>
          </Col>
        </Row>
      </Panel>
    </>
  )
}
